import React from 'react';
import { pick } from 'ramda';
import { Table } from 'js/components/common/Table';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import * as helpers from './helpers';
import * as actions from './store/actions';
import { LOGIN_HISTORY } from './constants';
import { withDynamicReducer, useDynamicReducerSelector, useDynamicReducerDispatch } from './store';

import * as style from './LoginHistory.scss';

export const LoginHistoryBare: React.FC = () => {
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();
    const { isLoading, error, page: { isPageChanged } } = useDynamicReducerSelector(pick(['isLoading', 'error', 'page']));
    const {
        filters,
        headerValidate,
        headerInitialValues,
        anotherPeriodFilter,
        onAnotherPeriodApply
    } = hooks.useTableHeader();
    const loadMore = hooks.useLoadMore();
    const tableData = hooks.useTableData();
    const tableSummary = hooks.useSummary();
    const { showLoginTable, showTotalLoginCount } = useComponentConfig();
    const emptyTitle = showLoginTable ? translate('empty') : '';

    // to prevent passing to request previous time if user leaves component and comes back (COR18-11145)
    useEffectOnce(() => {
        dispatch(actions.setData(helpers.getInitialPeriodData()));
    }, [dispatch]);

    hooks.useFetchComponent();

    if (!showLoginTable && !showTotalLoginCount) {
        return <span className={style.unavailable}>{translate('unavailable')}</span>;
    }

    return (
        <Table
            error={error}
            filters={filters}
            classNames={style}
            loadMore={loadMore}
            tableData={tableData}
            emptyTitle={emptyTitle}
            tableSummary={tableSummary}
            headerValidate={headerValidate}
            isLoading={isLoading && !isPageChanged}
            headerInitialValues={headerInitialValues}
            anotherPeriodFilter={anotherPeriodFilter}
            onAnotherPeriodApply={onAnotherPeriodApply}
        />
    );
};

export const LoginHistory = withComponent({
    isForLoggedIn: true,
    tkPrefix: 'playtech.mobile.system.login-history.'
})(withDynamicReducer()(LoginHistoryBare));

componentService.registerPageComponents({ [LOGIN_HISTORY]: LoginHistory });
